import brickingMyPhoneCover from '../assets/bricking_my_phone_cover.jpg';

const videoUrl = 'https://assets.salieflewis.com/bricking_my_phone_final.mov';

export function BrickingMyPhone() {
  return (
    <div className="flex h-full min-h-0 w-full items-center justify-center overflow-hidden p-4">
      <div className="flex h-full min-h-0 w-full max-w-[760px] items-center justify-center">
        {/* biome-ignore lint/a11y/useMediaCaption: The source video does not currently have captions. */}
        <video
          className="block h-auto max-h-full w-full bg-black object-contain"
          src={videoUrl}
          poster={brickingMyPhoneCover}
          controls
          playsInline
          preload="metadata"
        />
      </div>
    </div>
  );
}
